<template>
  <header class="app-header">
    <lang></lang>
    <div class="app-logo"></div>
    <lang></lang>
    <nav class="app-nav">
      <ul class="app-menu">
        <li class="menu-item" v-for="item in menu" :key="item.path">
          <a v-if="item.external" target="_blank" class="menu-link" :class="item.class" :href="item.external">{{ $t(`menu.${item.path.substring(1) || 'inicio'}`) }}</a>
          <router-link v-else class="menu-link" :class="path === item.path ? 'active' : ''" :to="item.path">{{ $t(`menu.${item.path.substring(1) || 'inicio'}`) }}</router-link>
          <ul class="menu-video" v-if="item.video">
            <li class="menu-video-content">
              <button class='video' :class="[item.video.class]"  @click="openModal(item)">
                {{ item.video.show }}
              </button>
            </li>
          </ul>
          <ul class="menu-video" v-if="item.link">
            <li class="menu-video-content">
              <a target="_blank" :href="item.link.url">
                <button class='video' :class="[item.link.class]" >
                  {{ item.link.show }}
                </button>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <article class="modal" ref="modal" @click="closeModal()">
      <div v-if="current" class="modal-content portada">
        <header><span class="close">&times;</span></header>
        <div class="modal-body">
          <h2 class="title">{{ current.video.titulo }}</h2>

          <iframe v-if="showModal" width="560" height="315" :src="current.video.url" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

          <p v-html="$t('inicio.modal.important')"></p>
        </div>
      </div>
    </article>
  </header>
</template>

<script>
import Lang from '@/components/util/Lang';
export default {
  components: {
    Lang
  },
  mounted () {
    this.path = this.$route.path;
  },
  data () {
    return {
      showModal: false,
      current: null,
      path: '/',
      menu: [
        { path: '/', label: this.$t('menu.inicio') },
        { path: '/paises', label: this.$t('menu.paises'), external: 'https://cancilleria.gob.bo/apostilla/paises-miembro/' },
        { path: '/tramite', label: this.$t('menu.tramite') },
        { path: '/solicitud', label: this.$t('menu.solicitud') },
        { path: '/seguimiento', label: this.$t('menu.seguimiento') },
        { path: '/verificar', label: this.$t('menu.verificar'), external: 'https://www.rree.gob.bo/VerificaApostilla', link: {titulo: this.$t('verificar.video'), show: this.$t('verificar.showVideo'), url: 'https://cancilleria.gob.bo/apostilla/tutoriales/', class: 'video-verificar'} },
        // { path: '/pagos', label: this.$t('menu.pagos'), external: 'https://www.rree.gob.bo/AdminApostilla/PagoTramite.aspx', link: {titulo: this.$t('pago.video'), show: this.$t('pago.showVideo'), url: 'https://cancilleria.gob.bo/apostilla/tutoriales/', class: 'video-pago'} },
        { path: '/pagos', label: this.$t('menu.pagos'), external: 'https://pagos.cancilleria.gob.bo/pagos/#/invitados/apostilla/pagos/registro' },
        // { path: '/verificar', label: this.$t('menu.verificar'), external: 'https://www.rree.gob.bo/VerificaApostilla', video: {titulo: this.$t('verificar.video'), show: this.$t('verificar.showVideo'), url: 'https://www.youtube.com/embed/bBggZxx2lSs?autoplay=1', class: 'video-verificar'} },
        // { path: '/pagos', label: this.$t('menu.pagos'), external: 'https://www.rree.gob.bo/AdminApostilla/PagoTramite.aspx', video: {titulo: this.$t('pago.video'), show: this.$t('pago.showVideo'), url: 'https://www.youtube.com/embed/Cx6rJ1NKmpQ?autoplay=1', class: 'video-pago'} },
        { external: 'https://www.cancilleria.gob.bo/transparencia/anfora/formulario', path: '/reclamos', label: this.$t('menu.inicio'), class: 'accent' },
        { path: '/contactos', label: this.$t('contacto.title') }
      ]
    };
  },
  watch: {
    '$route' (to, from) {
      this.path = to.path;
    }
  },
  methods: {
    // Modal ********************************************************************
    openModal (item) {
      this.current = item;
      this.showModal = true;
      this.$refs.modal.style.display = 'block';
    },
    closeModal () {
      this.current = null;
      this.showModal = false;
      this.$refs.modal.style.display = 'none';
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/scss/_variables.scss';

.accent {
  font-weight: 800;
  color: #0f6a95 !important;
  background: #d8f2ff;
}

.app-header {
  position: relative;
  z-index: 2;
}

.app-logo {
  width: 330px;
  height: 100px;
  margin: 14px auto 10px auto;
  background-image: url(../../../static/images/logo_apostilla_2.png);
  background-repeat: no-repeat;
  background-size: 100%;
}

@media (max-width: 768px) {
  .app-logo {
    width: 100%;
    max-width: 240px;
    height: 80px;
    margin: 20px auto 10px auto;
  }
}

.app-nav {
  width: 100%;
  border-bottom: 1px solid #e0e0e0;
  border-top: 1px solid #e0e0e0;
  text-align: center;
}

.app-menu {
  list-style: none;
  padding: 0;
  display: inline-block;
  margin: 0 auto;

  .menu-item {
    display: inline-block;
    text-transform: uppercase;
  }

  .menu-link {
    line-height: 42px;
    text-decoration: none;
    color: #333;
    padding: 0 15px;
    display: inline-flex;
    font-size: .9rem;
    position: relative;
    transition: all ease .3s;
    outline: 0;

    &:before {
      content: '';
      transition: all ease .3s;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      display: block;
      height: 2px;
    }

    &:hover, &.active {
      color: $primary;

      &:before {
        background-color: $primary;
      }
    }

    &:active, &:focus {
      outline: 0;
    }
  }
}
// Modal --------------------------------------------------------------
.video {
  padding: 5px 15px;
  border: none;
  font-weight: bold;
  cursor: pointer;
}

.video-verificar {
  background: #00a29c;
}

.video-verificar:hover {
  background: #01c5be;
}


.video-pago {
  background: #ce57e3;
}

.video-pago:hover {
  background: #e471f8;
}

.menu-item {
  position: relative;
  display: inline-block;
}

.menu-video-content {
  left: 0;
  display: none;
  list-style: none;
  min-width: 180px;
  position: absolute;
  z-index: 100;
}

.menu-item:hover .menu-video-content {
  display: block;
}

.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 30; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  position: relative;
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  border: 1px solid #888;
  width: 40%;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
  -webkit-animation-name: animatetop;
  -webkit-animation-duration: 0.4s;
  animation-name: animatetop;
  animation-duration: 0.4s
}

.modal-content header {
  padding: 0px 20px;
}

/* Add Animation */
@-webkit-keyframes animatetop {
  from {top:-300px; opacity:0}
  to {top:0; opacity:1}
}

@keyframes animatetop {
  from {top:-300px; opacity:0}
  to {top:0; opacity:1}
}

/* The Close Button */
.close {
  color: #000;
  float: right;
  font-size: 36px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  text-decoration: none;
  cursor: pointer;
  color: #707070
}

.modal-body {padding: 20px; text-align: center;}

@media (max-width: 868px) {
  .modal-content {
    width: 95%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/AppHeader.vue